import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, CardBody, Input, Button, Label, Spinner } from 'reactstrap';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import axios from 'axios';
import { mainurl } from '../../MainUrl';
import { toast } from 'react-toastify';
import { notification } from '../../component/hocs/notification';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DataTable from 'react-data-table-component';

const FinishedStockIn = () => {

  const [formData, setFormData] = useState({
    finished_product_name: '',
    stock_in: '',
    uom_id: '',
    batch_id: '',
    transaction_date: new Date().toISOString().split('T')[0], // Initial date value
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [productList, setProductList] = useState([]);
  const [machineList, setMachineList] = useState([]);
  // New State to Store Batch Details
const [batchDetails, setBatchDetails] = useState([]);
const [tableData, setTableData] = useState([]);

  const [uomOptions] = useState([
    { id: 1, name: 'Kilogram' },
    { id: 2, name: 'Gram' },
    { id: 3, name: 'Piece' },
    { id: 4, name: 'Liter' },
    { id: 5, name: 'Milliliter' },
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProductList();
    fetchMachineList();
  }, []);

  // Fetch Finished Product List
  const fetchProductList = async () => {
    try {
      const response = await axios.get(mainurl + 'product_list');
      if (Array.isArray(response.data.data)) {
        setProductList(response.data.data);
      } else {
        console.error('Invalid product data structure');
      }
    } catch (err) {
      console.error('Error fetching finished product list:', err);
      notification({ type: 'error', message: 'Error while fetching finished product list', position: 'bottom' });
    }
  };

  const fetchMachineList = async () => {
    try {
      const response = await axios.get(mainurl + 'product_view');
      if (Array.isArray(response.data.data)) {
        setMachineList(response.data.data);
      }
    } catch (err) {
      notification({ type: 'error', message: 'Error fetching batch list', position: 'bottom' });
    }
  };



  // Function to Fetch Batch Details
const fetchBatchDetails = async (batchId) => {
  try {
    const response = await axios.post(`${mainurl}product`, { batch_id: batchId });
    if (Array.isArray(response.data.data)) {
      setBatchDetails(response.data.data);
    } else {
      console.error('Invalid batch details structure');
    }
  } catch (err) {
    console.error('Error fetching batch details:', err);
    notification({ type: 'error', message: 'Error while fetching batch details', position: 'bottom' });
  }
};

// Effect to Fetch Details on Batch Selection
useEffect(() => {
  if (formData.batch_id) {
    fetchBatchDetails(formData.batch_id);
  } else {
    setBatchDetails([]); // Clear details if no batch selected
  }
}, [formData.batch_id]);


  // Handle form submission
  const handleSubmit = async () => {
    setLoading(true);
    setError('');

    // List of required fields
    const requiredFields = ['finished_product_name', 'batch_id', 'uom_id', 'transaction_date', 'stock_in'];

    // Array to hold missing fields
    let missingFields = [];

    // Check if all required fields are populated
    requiredFields.forEach(field => {
      if (!formData[field] || formData[field] === '') {
        missingFields.push(field);
      }
    });

    // If any fields are missing, log them and show an error
    if (missingFields.length > 0) {
      console.log('Missing fields:', missingFields);  // Log missing fields to the console
      setError(`Missing required fields: ${missingFields.join(', ')}`);  // Set error with missing fields
      notification({ type: 'error', message: `Please fill in the following fields: ${missingFields.join(', ')}`, position: 'bottom' });
      setLoading(false);
      return; // Stop the submission
    }

    // Log the stock_out value to check the actual value
    console.log('Stock in Value:', formData.stock_in);
  
    if (formData.stock_in === '' || isNaN(formData.stock_in) || formData.stock_in <= 0) {
      // Log the error and display the message
      console.error('Error: Stock in must be a valid number greater than 0');
      setError('Stock in must be a valid number greater than 0');
      notification({ type: 'error', message: 'Please enter a valid stock in value', position: 'bottom' });
      setLoading(false);
      return;
    }
    
    // Call the API
    try {
      const response = await axios.post(`${mainurl}product_in`, formData);
      if (response.status === 200) {
         toast.success('Finished Product Stock In successfully');
        setFormData({
          finished_product_name: '',
          stock_in: '',
          uom_id: '',
          batch_id: '',
          transaction_date: new Date().toISOString().split('T')[0],
        });
      } else {
        setError('Failed to create');
        notification({ type: 'error', message: 'Failed to save product', position: 'bottom' });
      }
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err);
      setError('Failed to create');
      notification({ type: 'error', message: 'Error while saving product', position: 'bottom' });
    } finally {
      setLoading(false);
    }
  };

  // Reset form fields
  const resetForm = () => {
    setFormData({
      finished_product_name: '',
      stock_in: '',
      uom_id: '',
      batch_id: '',
      transaction_date: new Date().toISOString().split('T')[0], // Reset to current date
    });
  };


  const handleBatchChange = (e) => {
    const selectedBatchId = e.target.value;
    setFormData({ ...formData, batch_id: selectedBatchId });
    fetchBatchDetails(selectedBatchId);
  };


  // Custom table styling to improve alignment and make header more prominent
  const custTableStyles = {
    rows: {
      highlightOnHover: true,
      style: {
        textAlign: 'center', // Align row content to center
      },
    },
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#FF0000', // Set header background color to red
        color: 'white', // Set header text color to white
        textAlign: 'center', // Center-align header cells
      },
    },
    cells: {
      style: {
        //padding: '10px', // Add padding to table cells
        textAlign: 'center', // Align cell content to the center by default
      },
    },
  };


  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-3">
            <Title pageTitle="Finished Product Stock In" />
          </Col>
          <Col xs={12}>
            <Card color="primary" outline className="mb-3">
              <CardBody>
                <Row className="my-2">
                  
                  {/* Select Batch */}
                  <Col md={6} className="mt-2">
                    <Label>Select Batch</Label>
                    <Input
                      type="select"
                      value={formData.batch_id}
                      onChange={handleBatchChange}
                      required
                    >
                      <option value="">Select Batch</option>
                      {machineList.map((machine) => (
                        <option key={machine.batch_id} value={machine.batch_id}>
                          {machine.batch_no}
                        </option>
                      ))}
                    </Input>
                  </Col>
                

                {/* Conditional Table Rendering */}
{/* Conditional Table Rendering */}
{formData.batch_id && (
  <div className="datatable">
    <div className="customstyles">
      <DataTable
        columns={[
          {
            name: 'Raw Material Name',
            selector: row => row.raw_material_name 
              ? `${row.raw_material_name} ${row.raw_quantity} ${row.raw_uom}` 
              : 'No Name Available', // Concatenate raw name, quantity, and UOM
            sortable: true,
          },
          {
            name: 'Machine No',
            selector: row => row.machine_no,
            sortable: true,
          },
          {
            name: 'Start Date',
            selector: row => row.start_date && row.start_time
              ? `${row.start_date} ${row.start_time}`  // Correct concatenation of date and time
              : 'No Start Date Available', // Fallback if either date or time is missing
            sortable: true,
            wrap: true,
            style: { 
              textAlign: 'center', 
              marginLeft: '20px',  // Add left margin for space between columns
            },
          }
          
        ]}
        data={batchDetails}
        customStyles={custTableStyles} // Apply custom styles
        noHeader // Optional: Add or remove based on your requirement
        pagination
        defaultSortField="Raw Material Name"
      />
    </div>
  </div>
)}
{/* Finished Product Name */}
<Col md={6} className="mt-2">
                    <Label>Finished Product Name</Label>
                    <Input
                      type="select"
                      value={formData.finished_product_name}
                      onChange={(e) => setFormData({ ...formData, finished_product_name: e.target.value })}
                      required
                    >
                      <option value="">Select Finished Product</option>
                      {productList.map((product) => (
                        <option key={product.finished_product_id} value={product.finished_product_name}>
                          {product.finished_product_name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  </Row>




                {/* Stock In Quantity */}
                <Row className="my-2">
                  <Col md={6} className="mt-2">
                    <Label>Stock In Quantity</Label>
                    <Input
                      placeholder="Enter Stock In Quantity"
                      type="number"
                      min="1"
                      value={formData.stock_in}
                      onChange={(e) => setFormData({ ...formData, stock_in: parseFloat(e.target.value) || '' })}
                      required
                    />
                  </Col>

                  {/* UOM */}
                  <Col md={6} className="mt-2">
                    <Label>Unit of Measurement (UOM)</Label>
                    <Input
                      type="select"
                      value={formData.uom_id}
                      onChange={(e) => setFormData({ ...formData, uom_id: e.target.value })}
                      required
                    >
                      <option value="">Select UOM</option>
                      {uomOptions.map((uomOption) => (
                        <option key={uomOption.id} value={uomOption.id}>
                          {uomOption.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>

                {/* Transaction Date */}
                <Row className="my-2">
                  <Col md={6}>
                    <Label>Batch Closed Date</Label>
                    <DatePicker
                      selected={formData.transaction_date ? new Date(formData.transaction_date) : null}
                      onChange={(date) => setFormData({ ...formData, transaction_date: date })}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select a date"
                      className="form-control"
                      required
                    />
                  </Col>
                </Row>

                <Button className="mt-3" color="primary" onClick={handleSubmit} disabled={loading}>
                  {loading ? <Spinner size="sm" /> : 'Closed Batch'}
                </Button>
                {error && <div className="mt-3 text-danger">{error}</div>}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default FinishedStockIn;